// extracted by mini-css-extract-plugin
export default {"container":"styles_container__iu1PN","body":"styles_body__4WcCS"};